import React, { useState, useEffect } from 'react';
import { ArrowUpDown } from 'lucide-react';

export const PartnerTable = ({ data, sortConfig, onSort, onPartnerClick }) => {
  const columns = [
    { key: 'partner', label: 'PARTNER NAME', sortable: false },
    { key: 'countries_cnt', label: 'COUNTRIES', sortable: false },
    { key: 'dcu_cnt', label: 'DCUS', sortable: false },
    { key: 'connected_dcu_cnt', label: 'CONNECTED DCUS', sortable: false },
    { key: 'active_ppu_cnt', label: 'ACTIVE PPUS', sortable: false },
    { key: 'ppu_compliance', label: 'PPU COMPLIANCE', sortable: false },
    { key: 'consumer_record_cnt', label: 'CONSUMER RECORDS', sortable: false },
    { key: 'last_seen_at', label: 'LATEST RECORD', sortable: false }
  ];

  
  return (
    <div className="overflow-x-auto"  style={{ maxHeight: "750px" }}>
      <table className="w-full">
        <thead className="bg-gray-50 sticky top-0 z-10">
          <tr className="border-b border-gray-200">
            {columns.map((col) => (
              <th
                key={col.key}
                className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider py-3 px-4 cursor-pointer hover:bg-gray-50"
                onClick={() => col.sortable && onSort(col.key)}
              >
                <div className="flex items-center gap-1">
                  {col.label}
                  {col.sortable && <ArrowUpDown className={`w-3 h-4 cursor-pointer ${sortConfig.key === col.key ? 'text-red-500 rotate-180' : 'text-gray-400'}`}/>}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={`${row.partner}-${index}`} className="border-b border-gray-100 hover:bg-gray-50">
              <td className="text-blue-600 hover:text-blue-800 hover:underline font-medium cursor-pointer transition-colors duration-150" 
                  onClick={() => onPartnerClick(row.partner)}>
                  {row.partner}
              </td>
              <td className="py-4 px-4 text-gray-700">{row.countries_cnt}</td>
              <td className="py-4 px-4 text-gray-700">{row.dcu_cnt}</td>
              <td className={`py-4 px-4 font-medium ${row.connected_dcu_cnt === 0 ? 'text-red-600' : 'text-green-600'}`}>
                {row.connected_dcu_cnt}
              </td>
              <td className="py-4 px-4 text-gray-700">{row.active_ppu_cnt}</td>
              <td className="py-4 px-4 text-gray-700">'N/A'</td>
              <td className="py-4 px-4 text-gray-700 text-sm">{row.consumer_record_cnt.toLocaleString()}</td>
              <td className="py-4 px-4 text-gray-700 text-sm">{row.last_seen_at.split("T")[0]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};